import React, { memo, forwardRef } from "react";
const SvgCapitalS = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.28 20.34c.347.307.727.547 1.14.72.414.16.834.24 1.26.24.293 0 .593-.033.9-.1.307-.08.58-.207.82-.38a1.96 1.96 0 00.6-.64c.16-.267.24-.593.24-.98 0-.373-.086-.68-.26-.92a2.166 2.166 0 00-.7-.64 4.699 4.699 0 00-1.04-.48l-1.26-.42a12.467 12.467 0 01-1.28-.48 4.404 4.404 0 01-1.16-.74 3.69 3.69 0 01-.82-1.12c-.213-.453-.32-1.013-.32-1.68 0-.72.147-1.34.44-1.86.307-.52.7-.947 1.18-1.28a5.098 5.098 0 011.66-.76 6.88 6.88 0 011.88-.26c.574 0 1.134.08 1.68.24.56.147 1.04.373 1.44.68.253.187.42.367.5.54.08.173.12.347.12.52 0 .307-.107.567-.32.78-.2.213-.46.32-.78.32-.107 0-.22-.013-.34-.04-.12-.04-.287-.133-.5-.28-.36-.253-.7-.427-1.02-.52a3.165 3.165 0 00-.88-.14c-.293 0-.587.04-.88.12a2.38 2.38 0 00-.8.34c-.24.147-.44.347-.6.6-.146.24-.22.533-.22.88 0 .32.067.593.2.82.133.227.313.42.54.58.24.16.527.3.86.42.333.12.7.24 1.1.36.453.147.92.313 1.4.5.494.187.94.433 1.34.74.414.307.747.693 1 1.16.267.467.4 1.047.4 1.74 0 .76-.14 1.427-.42 2a4.132 4.132 0 01-1.12 1.4 4.777 4.777 0 01-1.64.84 6.9 6.9 0 01-1.98.28 7.237 7.237 0 01-2.14-.32c-.68-.2-1.26-.513-1.74-.94-.226-.187-.38-.367-.46-.54a1.508 1.508 0 01-.1-.5c0-.32.107-.593.32-.82.227-.24.514-.36.86-.36.133 0 .273.027.42.08.147.053.307.153.48.3z"
      />
    </svg>
  );
});
SvgCapitalS.displayName = "SvgCapitalS";
const MemoForwardRef = memo(SvgCapitalS);
export default MemoForwardRef;
